export const fieldNameSecuritySection = <const>{
    session: 'useSession',
};
